var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5381_22288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1089 20.7891C17.0668 20.7891 17.8504 20.0055 17.8504 19.0477C17.8504 18.0898 17.0668 17.3062 16.1089 17.3062C15.1511 17.3062 14.3674 18.0898 14.3674 19.0477C14.3674 20.0055 15.1511 20.7891 16.1089 20.7891ZM21.3334 12.9524H20.4627V11.2109C20.4627 8.80765 18.5122 6.85718 16.1089 6.85718C13.7057 6.85718 11.7552 8.80765 11.7552 11.2109H13.4096C13.4096 9.72194 14.62 8.5116 16.1089 8.5116C17.5979 8.5116 18.8082 9.72194 18.8082 11.2109V12.9524H10.8844C9.92662 12.9524 9.14294 13.7361 9.14294 14.6939V23.4014C9.14294 24.3592 9.92662 25.1429 10.8844 25.1429H21.3334C22.2912 25.1429 23.0749 24.3592 23.0749 23.4014V14.6939C23.0749 13.7361 22.2912 12.9524 21.3334 12.9524ZM21.3334 23.4014H10.8844V14.6939H21.3334V23.4014Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5381_22288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.26121b2c.svg";
export { ForwardRef as ReactComponent };